if (document.readyState === "complete" || document.readyState === "interactive") {
  setTimeout(initRepeatableContainers);
} else {
  document.addEventListener("DOMContentLoaded", initRepeatableContainers);
}

const toggleCopyButtons = function() {
  const repeatableContainers = document.querySelectorAll('[data-repeatable-container][data-is-root]');

  repeatableContainers.forEach(container => {
    const identifier = container.dataset.identifier;
    const form = container.closest('form');
    const copyButtons = form.querySelectorAll(`[data-repeatable-container][data-copy-button-for="${identifier}"]`);

    copyButtons.forEach(copyButton => copyButton.hidden = true);
    copyButtons[copyButtons.length -1].hidden = false;
  });
};

const getNextCopyNumber = function(referenceElement, form) {
    let highestCopyNumber = 0;
    const selector = `[data-repeatable-container][data-copy-reference="${referenceElement.dataset.identifier}"]`;

    form.querySelectorAll(selector).forEach((el) => {
      const copyNumber = parseInt(el.dataset.identifier.split('.').pop());
      if (copyNumber > highestCopyNumber) {
        highestCopyNumber = copyNumber;
      }
    });
    return ++highestCopyNumber;
  },
  setRandomIds = function(subject) {
    const idReplacements = {};

    subject.querySelectorAll('[id]').forEach((el) => {
      const id = el.getAttribute('id');
      const newId = Math.floor(Math.random() * 42) + Date.now();
      el.setAttribute('id', newId);
      idReplacements[id] = newId;
    });

    subject.querySelectorAll('*').forEach((el) => {
      el.getAttributeNames().forEach((attributeName) => {
        const attributeValue = el.getAttribute(attributeName);
        if (attributeValue in idReplacements) {
          el.setAttribute(attributeName, idReplacements[attributeValue]);
        }
      });
    });

  },
  escapeRegExp = function(subject) {
    return subject.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  },
  insertAfter = function(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  };

const containerClones = {};

function onCopyClickCallback(event) {
  event.preventDefault();
  var element = this,
    referenceElementIdentifier = element.getAttribute('data-copy-button-for'),
    form = element.closest('form'),
    formIdentifier = form.getAttribute('id'),
    referenceElement = form.querySelector(`[data-repeatable-container][data-identifier="${referenceElementIdentifier}"]`),
    referenceElementIsRoot = referenceElement.hasAttribute('data-is-root'),
    elementCopies = form.querySelectorAll(`[data-repeatable-container][data-copy-reference="${referenceElementIdentifier}"]`),
    containerCloneIdentifier = referenceElementIsRoot ? referenceElementIdentifier : referenceElement.getAttribute('data-copy-reference'),
    copyMotherIdentifier = containerClones[formIdentifier][containerCloneIdentifier].getAttribute('data-identifier'),
    newIdentifierParts = referenceElement.getAttribute('data-identifier').split('.'),
    oldIdentifierNameRegex = escapeRegExp('[' + copyMotherIdentifier.split('.').join('][') + ']'),
    copyMotherIdentifierRegex = '(' + escapeRegExp('data-copy-mother="') + ')?' + escapeRegExp(copyMotherIdentifier),
    newIdentifier = undefined,
    newIdentifierNameRegex = undefined,
    containerClone = undefined,
    containerCloneHtml = undefined;

  newIdentifierParts.pop();
  newIdentifierParts.push(getNextCopyNumber(referenceElement, form));
  newIdentifier = newIdentifierParts.join('.');

  containerCloneHtml = containerClones[formIdentifier][containerCloneIdentifier].outerHTML;
  // leading, negative lookbehind ("?<!")
  containerCloneHtml = containerCloneHtml.replace(new RegExp(copyMotherIdentifierRegex, 'g'), function($0, $1) {
    return $1 ? $0 : newIdentifier;
  });

  newIdentifierNameRegex = '[' + newIdentifierParts.join('][') + ']';
  containerCloneHtml = containerCloneHtml.replace(new RegExp(oldIdentifierNameRegex, 'g'), newIdentifierNameRegex);

  const dummyElement = document.createElement('div');
  dummyElement.innerHTML = containerCloneHtml;

  containerClone = dummyElement.firstChild;
  containerClone.setAttribute('data-copy-reference', referenceElementIdentifier);
  containerClone.querySelectorAll('input, textarea, select').forEach((e) => {
    switch (e.type) {
      case 'radio':
      case 'checkbox':
        e.checked = false;
        break;
      default:
        e.value = '';
    }
  });

  const cloneButton = containerClone.querySelector('[data-copy-button]');
  if (cloneButton) {
    cloneButton.setAttribute('data-copy-button-for', referenceElementIdentifier)
  }

  setRandomIds(containerClone);

  if (elementCopies.length === 0) {
    insertAfter(containerClone, referenceElement);
  } else {
    insertAfter(containerClone, elementCopies[elementCopies.length -1]);
  }

  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-copy', {detail: [containerClone]}));
  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-init-copy-buttons', {detail: [containerClones]}));
  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-init-remove-buttons'));
}

function onRemoveClickCallback(event) {
  event.preventDefault();
  var element = this,
    referenceElementIdentifier = element.getAttribute('data-remove-button-for'),
    form = element.closest('form'),
    referenceElement = form.querySelector(`[data-repeatable-container][data-identifier="${referenceElementIdentifier}"]`),
    referenceElementIsRoot = referenceElement.hasAttribute('data-is-root'),
    referenceReferenceElementIdentifier = referenceElementIsRoot ? referenceElementIdentifier :referenceElement.getAttribute('data-copy-reference'),
    elementCopies = form.querySelectorAll(`[data-repeatable-container][data-copy-reference="${referenceReferenceElementIdentifier}"]`),
    maxCopies = referenceElement.dataset.maxCopies,
    copyButtons = form.querySelectorAll(`[data-repeatable-container][data-copy-button-for="${referenceReferenceElementIdentifier}"]`);


  if (elementCopies.length - 1 < maxCopies) {
    copyButtons.forEach(element => element.removeAttribute('disabled'));
  }

  referenceElement.remove();

  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-remove'));
  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-init-remove-buttons'));
}


function initRepeatableContainers() {
  /** @type {NodeListOf<HTMLElement>} */
  const repeatableContainers = document.querySelectorAll('[data-repeatable-container][data-is-root]');

  if (repeatableContainers.length === 0) {
    return;
  }

  toggleCopyButtons();
  document.addEventListener('toujou-form-repeatable-element-init-copy-buttons', () => {
    document.querySelectorAll('[data-repeatable-container][data-copy-button]').forEach((element) => {

      const referenceElementIdentifier = element.getAttribute('data-copy-button-for');
      const form = element.closest('form');

      const referenceElement = form.querySelector(`[data-repeatable-container][data-identifier="${referenceElementIdentifier}"]`);
      const elementCopies = form.querySelectorAll(`[data-repeatable-container][data-copy-reference="${referenceElementIdentifier}"]`);
      const maxCopies = referenceElement.dataset.maxCopies;

      if (elementCopies.length >= maxCopies) {
        element.setAttribute('disabled', 'disabled');
      } else {
        element.removeAttribute('disabled');
      }
      element.removeEventListener('click', onCopyClickCallback);
      element.addEventListener('click', onCopyClickCallback);
    });
  });

  document.addEventListener('toujou-form-repeatable-element-init-remove-buttons', () => {
    document.querySelectorAll('[data-repeatable-container][data-remove-button]').forEach((element) => {

      const referenceElementIdentifier = element.getAttribute('data-remove-button-for');
      const form = element.closest('form');

      const referenceElement = form.querySelector(`[data-repeatable-container][data-identifier="${referenceElementIdentifier}"]`);
      const referenceElementIsRoot = referenceElement.hasAttribute('data-is-root');
      const referenceReferenceElementIdentifier = referenceElementIsRoot ? referenceElementIdentifier :referenceElement.getAttribute('data-copy-reference');

      const elementCopies = form.querySelectorAll(`[data-repeatable-container][data-copy-reference="${referenceReferenceElementIdentifier}"]`);

      const minCopies = referenceElement.dataset.minCopies;

      if (referenceElement.hasAttribute('data-copy-reference') && referenceElement.getAttribute('data-copy-reference') !== '') {
        if (elementCopies.length <= minCopies) {
          element.hidden = true;
          element.disabled = true;
        } else {
          element.hidden = false;
          element.disabled = false
        }
      } else {
        element.remove();
      }

      if (element.disabled) {
        element.removeEventListener('click', onRemoveClickCallback);

      } else {
        element.addEventListener('click', onRemoveClickCallback);
      }
    });
  });

  ['toujou-form-repeatable-element-copy', 'toujou-form-repeatable-element-remove'].forEach((eventName) => {
      document.addEventListener(eventName, () => {

        toggleCopyButtons();
        document.querySelectorAll('form').forEach((form) => {
          if (form.hasOwnProperty('pristine')) {
            form.pristine.destroy();
            form.querySelectorAll('[type="submit"][disabled]').
              forEach((button) => button.disabled = false);
          }
        });
        document.dispatchEvent(new CustomEvent('toujou-form-init'));
      });
  });

  repeatableContainers.forEach(function(element) {
    /** @type {HTMLElement} */
    const containerClone = element.cloneNode(true);
    const containerIdentifier =  element.dataset.identifier;
    const formIdentifier = element.closest('form').getAttribute('id');

    const childsToRemove = containerClone.querySelectorAll(`[data-repeatable-container][data-is-copy]`);

    containerClones[formIdentifier] = containerClones[formIdentifier] || {};

    childsToRemove.forEach(function(childElement) {
      childElement.remove()
    });

    containerClone.querySelectorAll('[data-repeatable-container][data-is-root]').forEach(function(subContainerElement) {
      subContainerElement.removeAttribute('data-is-root');
      subContainerElement.setAttribute('data-is-copy');
      subContainerElement.setAttribute('data-copy-mother', subContainerElement.getAttribute('data-identifier'));
    });

    containerClone.removeAttribute('data-is-root');
    containerClone.setAttribute('data-is-copy', '');
    containerClone.querySelectorAll('.has-error').forEach((e) => e.classList.remove('has-error'));
    containerClones[formIdentifier][containerIdentifier] = containerClone;
  });

  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-init-copy-buttons', {detail: [containerClones]}));
  document.dispatchEvent(new CustomEvent('toujou-form-repeatable-element-init-remove-buttons'));
}
